"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShowHide = void 0;
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.object.get-prototype-of.js");
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _contentDispatch = require("../../framework/components/contentDispatch");
var _excluded = ["renderAs", "toMatch", "data", "rootPath", "shouldDisplay", "shouldDisplayRules", "setCurrentFieldList", "loading", "dependencies", "isHidden", "contentMap", "propsToChild"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ShowHide = /*#__PURE__*/function (_React$Component) {
  _inherits(ShowHide, _React$Component);
  var _super = _createSuper(ShowHide);
  function ShowHide() {
    _classCallCheck(this, ShowHide);
    return _super.apply(this, arguments);
  }
  _createClass(ShowHide, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this = this;
      var dependencies = _lodash.default.get(this.props, 'dependencies');
      var update = false;
      if (!_lodash.default.isEqual(nextProps.data, this.props.data)) {
        update = true;
      } else if (!_lodash.default.isEqual(nextProps.config, this.props.config)) {
        update = true;
      }
      _lodash.default.forEach(dependencies, function (dep) {
        _lodash.default.forEach(dep, function (depPath, depName) {
          if (!_lodash.default.isEqual(nextProps[depName], _this.props[depName])) {
            update = true;
            return;
          }
        });
      });
      if (!_lodash.default.isEqual(this.props.validationErrors, nextProps.validationErrors)) {
        update = true;
      }
      return update;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        renderAs = _this$props.renderAs,
        toMatch = _this$props.toMatch,
        data = _this$props.data,
        rootPath = _this$props.rootPath,
        shouldDisplay = _this$props.shouldDisplay,
        shouldDisplayRules = _this$props.shouldDisplayRules,
        setCurrentFieldList = _this$props.setCurrentFieldList,
        loading = _this$props.loading,
        dependencies = _this$props.dependencies,
        isHidden = _this$props.isHidden,
        contentMap = _this$props.contentMap,
        propsToChild = _this$props.propsToChild,
        restProps = _objectWithoutProperties(_this$props, _excluded);
      var shouldComponentHide = isHidden || !shouldDisplay(data, toMatch, shouldDisplayRules, this.props);
      var isLoading = _lodash.default.find(dependencies, function (dep) {
        return _lodash.default.get(dep, 'loading') !== undefined;
      }) && (loading !== undefined ? loading : true);
      var additionalProps = {};
      _lodash.default.each(propsToChild, function (key) {
        additionalProps[key] = _lodash.default.get(restProps, key, key);
      });
      if (!isLoading && renderAs.type && !shouldComponentHide) {
        return /*#__PURE__*/_react.default.createElement(_contentDispatch.ContentDispatch, _extends({
          contentMap: contentMap,
          config: renderAs,
          rootPath: rootPath,
          setCurrentFieldList: setCurrentFieldList,
          isHidden: shouldComponentHide
        }, additionalProps));
      } else {
        return /*#__PURE__*/_react.default.createElement("span", {
          className: "emptyWrapper"
        }); // Added to recognize this wrapper in the styles
      }
    }
  }]);
  return ShowHide;
}(_react.default.Component);
exports.ShowHide = ShowHide;